if (!customElements.get('ly-main-product-form-variant-picker')) {
    customElements.define('ly-main-product-form-variant-picker', class extends HTMLElement {

        keyIdMap = null
        idKeyMap = null

        connectedCallback() {
            this.keyIdMap = readJsonFromScript(this.querySelector('script[type="application/json"][data-key-id]'))
            this.idKeyMap = readJsonFromScript(this.querySelector('script[type="application/json"][data-id-key]'))

            this.lines = [...this.querySelectorAll('.ly-main-product-form-variant-picker')]

            this.addEventListener('variant_changed', this.handleVariantChange)

            // 处理在监听事件前发生的变化
            requestAnimationFrame(() => {
                if (this.keyIdMap[this.activedKey] !== this.dataset.variantId) {
                    console.log(`当前选中的多属性和初始加载的多属性不一致，进行修复 ${this.dataset.variantId} -> ${this.keyIdMap[this.activedKey]}`)
                    this.handleVariantChange()
                }
            })
        }

        disconnectedCallback() {
            this.removeEventListener('variant_changed', this.handleVariantChange)
        }

        handleVariantChange = () => {
            if (!this.keyIdMap[this.activedKey]) {
                const selectedValues = this.activedKey.split(' | ')
                const startKey = selectedValues.slice(0, -1).join(' | ')
                const fixedActivedKey = Object.keys(this.keyIdMap).find(key => key.startsWith(startKey))
                const fixedSelectedValues = fixedActivedKey.split(' | ')
                fixedSelectedValues.forEach((value, index) => {
                    this.lines[index].selectValue(value)
                })
                return
            }

            window.publish('bus:variant_picker_change', {
                variantId: this.keyIdMap[this.activedKey],
                activedKey: this.activedKey,
                activedOptions: this.activedOptions
            })
        }

        get activedKey() {
            return this.lines.map(line => line.activedValue).join(' | ')
        }

        get activedOptions() {
            return this.lines.map(line => line.activedOption)
        }
    })
}

class LyMainProductFormVariantPickerLineBase extends HTMLElement {
    checkboxs = []
    checkboxValueMap = new WeakMap()
    valueCheckboxMap = new Map()
    valueDom = null

    connectedCallback() {
        this.checkboxs = [...this.querySelectorAll('.ly-main-product-form-variant-picker-option-picker-checkbox')]
        this.valueDom = this.querySelector('.ly-main-product-form-variant-picker-header-left-value')

        this.checkboxs.forEach(checkbox => {
            const value = checkbox.dataset.showValue ?? checkbox.value
            this.checkboxValueMap.set(checkbox, value)
            this.valueCheckboxMap.set(value, checkbox)
            checkbox.addEventListener('change', this.handleOptionChange)
        })
    }

    disconnectedCallback() {
        this.checkboxs.forEach(checkbox => checkbox.removeEventListener('change', this.handleOptionChange))
    }

    handleOptionChange = ({ target }) => {
        let value = this.checkboxValueMap.get(target)
        if (!value) {
            value = checkbox.dataset.showValue ?? checkbox.value
            this.checkboxValueMap.set(target, value)
            this.valueCheckboxMap.set(value, target)
        }
        this.valueDom.textContent = value

        this.dispatchEvent(new CustomEvent('variant_changed', {
            bubbles: true
        }))

        this._onOptionChange(value)

    }

    _onOptionChange = (value) => { }

    get selectedCheckbox() {
        return this.checkboxs.find(item => item.checked) || this.checkboxs[0]
    }

    get activedValue() {
        if (!this.selectedCheckbox) return null
        return this.selectedCheckbox.value
    }

    get activedOption() {
        if (!this.selectedCheckbox) return null
        return this.selectedCheckbox.dataset.optionId
    }

    selectValue = value => {
        if (this.activedValue === value) return
        const target = this.valueCheckboxMap.get(value)
        target.checked = true
        target.dispatchEvent(new Event('change'))

        if (this.pergolaSizeTabContents) {
            this.pergolaSizeTabContents.forEach((content, index) => {
                if (content.contains(target) && !content.classList.contains('is-visible')) {
                    this.pergolaSizeTabs[index].click()
                }
            })
        }
    }
}

if (!customElements.get('ly-main-product-form-variant-picker-line')) {
    customElements.define('ly-main-product-form-variant-picker-line', LyMainProductFormVariantPickerLineBase)
}

if (!customElements.get('ly-main-product-form-variant-picker-line-v2-option1')) {
    customElements.define('ly-main-product-form-variant-picker-line-v2-option1', class extends LyMainProductFormVariantPickerLineBase {

        connectedCallback() {
            super.connectedCallback()

            requestAnimationFrame(() => {
                if (this.activedValue !== this.dataset.layout) {
                    this.publishEvent(this.activedValue)
                }
            })
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onOptionChange = (layout) => this.publishEvent(layout)

        publishEvent = layout => {
            window.publish('bus:ly-main-product-form-variant-picker-line-v2-option1:change', layout)
        }
    })
}

if (!customElements.get('ly-main-product-form-variant-picker-line-v2-option3')) {
    customElements.define('ly-main-product-form-variant-picker-line-v2-option3', class extends LyMainProductFormVariantPickerLineBase {

        options = null
        sizes = null
        types = null

        connectedCallback() {
            super.connectedCallback()

            this.pergolaSizeTabSelector = this.querySelector('.ly-main-product-form-variant-picker-v2-pergola-option3-tabs')
            if (this.pergolaSizeTabSelector) {
                this.pergolaSizeTabs = [...this.pergolaSizeTabSelector.querySelectorAll('label')]
                this.pergolaSizeTabContents = [...this.querySelectorAll('.ly-main-product-form-variant-picker-option-container .ly-main-product-form-variant-picker-option-wrapper')]
            }

            this.pergolaSizeTabSelector?.addEventListener('change', this.handleTabChange)

            const optionsScript = this.querySelector('script[type="application/json"][data-options]')
            if (optionsScript) {
                this.options = readJsonFromScript(optionsScript)
            }

            const sizesScript = this.querySelector('script[type="application/json"][data-sizes]')
            if (sizesScript) {
                this.sizes = readJsonFromScript(sizesScript)
            }

            const typesScript = this.querySelector('script[type="application/json"][data-types]')
            if (typesScript) {
                this.types = readJsonFromScript(typesScript)
            }

            this.contentsWrapper = this.querySelector('.ly-main-product-form-variant-picker-option-container')

            this.layoutChangeUnsubcscriber = window.subscribe('bus:ly-main-product-form-variant-picker-line-v2-option1:change', this.handleLayoutChange)
        }

        disconnectedCallback() {

            this.pergolaSizeTabSelector?.removeEventListener('change', this.handleTabChange)

            this.layoutChangeUnsubcscriber?.()

            super.disconnectedCallback()
        }

        handleTabChange = evt => {
            this.pergolaSizeTabContents.forEach(content => {
                content.classList.toggle('is-visible', evt.target.value === content.dataset.type)
            })
        }

        handleLayoutChange = (layout) => {
            const currentTypes = this.types.filter(type => type.layout === layout)
            const activeType = currentTypes.find(type => {
                return type.variants.some(id => this.selectedVariantId === id)
            })

            this.renderTabs(currentTypes, activeType)

            this.renderContents(currentTypes, activeType)

            this.refresh()
        }

        renderTabs = (currentTypes, activeType) => {
            this.pergolaSizeTabSelector.innerHTML = currentTypes.map(type => {
                let tooltipHtml = ''
                if (type.tooltip) {
                    tooltipHtml = `
                    <div class="ly-main-product-form-variant-picker-v2-pergola-option3-tab-tooltip">
                        ${type.tooltip.icon ? `<div class="svg-wrapper">${type.tooltip.icon}</div>` : ''}
                        <div class="ly-main-product-form-variant-picker-v2-pergola-option3-tab-tooltip-inner">
                            <div class="ly-main-product-form-variant-picker-v2-pergola-option3-tab-tooltip-title">
                                ${type.tooltip.title}
                            </div>
                        </div>
                    </div>   
                    `
                }

                return `
                <label class="ly-main-product-form-variant-picker-v2-pergola-option3-tab">
                    ${type.icon ? `<span class="svg-wrapper">${type.icon}</span>` : ''}
                    <span class="ly-main-product-form-variant-picker-v2-pergola-option3-tab-title">${type.type}</span>

                    <input 
                    type="radio"
                    name="ly-main-product-form-variant-picker-v2-pergola-option3-tab-radio"
                    value="${type.type}"
                    class="ly-hide ly-main-product-form-variant-picker-v2-pergola-option3-tab-radio"
                    ${activeType.type === type.type ? 'checked' : ''}
                    >
                    ${tooltipHtml}
                </label>
                `
            }).join('')
        }

        renderContents = (currentTypes, activeType) => {
            const { option1, option2, option3 } = this.selectedOptions

            this.contentsWrapper.innerHTML =
                currentTypes.map(type => {

                    const html = this.sizes.flatMap(size => {

                        const matchedVariants =
                            size.variants.filter(variant => {
                                const [vOption1, vOption2] = variant.options
                                return (vOption1 === option1 && vOption2 === option2)
                            })

                        if (!matchedVariants.length) {
                            return []
                        }

                        return matchedVariants.flatMap(matchedVariant => {
                            if (!type.variants.includes(matchedVariant.id)) {
                                return []
                            }

                            const checked = matchedVariant.options[2] === option3

                            const option = this.options.find(item => item.value === matchedVariant.options[2])

                            let componentsTitleHtml = ''

                            if (size.componentsTitle) {
                                componentsTitleHtml = `
                                <div class="ly-main-product-form-variant-picker-option-components-title">
                                    ${size.componentsTitle}
                                </div>
                                `
                            }

                            let tagHtml = ''

                            if (size.tag) {
                                tagHtml = `
                                <div class="ly-main-product-form-variant-picker-option-tag">
                                    ${size.tag}
                                </div>
                                `
                            }

                            let variant_size_tag_html = ''
                            const { variant_size_tag } = matchedVariant
                            if (variant_size_tag) {

                                variant_size_tag_html = `
                                <div
                                  class="ly-main-product-form-variant-picker-option-variant_size_tag"
                                  style="--bg-1: ${variant_size_tag.bg_1};--bg-2: ${variant_size_tag.bg_2};"
                                >
                                  ${variant_size_tag.title}
                                </div>
                                `
                            }

                            return `
                            <label class="ly-main-product-form-variant-picker-option v2-pergola-option3">
                            ${variant_size_tag_html}
                            <div class="ly-main-product-form-variant-picker-option-title ly-p">
                                ${size.showTitle}
                            </div>

                            ${componentsTitleHtml}

                            ${tagHtml}

                            <input
                                class="ly-main-product-form-variant-picker-option-picker-checkbox"
                                type="radio"
                                name="Pergola Size"
                                value="${matchedVariant.options[2]}"
                                data-show-value="${size.showTitle}"
                                data-option-id="${option?.id ?? ''}"
                                ${checked ? 'checked' : ''}
                                ${!matchedVariant.available ? 'disabled' : ''}
                                hidden
                            >
                        </label>
                        `
                        })
                    }).join('')

                    return `
                    <div class="ly-main-product-form-variant-picker-option-wrapper has-v2-pergola-option3 ${type.type === activeType.type ? 'is-visible' : ''}" data-type="${type.type}">
                        ${html}
                    </div>
                    `
                }).join('')
        }

        refresh = () => {
            this.pergolaSizeTabs = [...this.pergolaSizeTabSelector.querySelectorAll('label')]

            this.pergolaSizeTabContents = [...this.querySelectorAll('.ly-main-product-form-variant-picker-option-container .ly-main-product-form-variant-picker-option-wrapper')]

            // 移除旧监听
            this.checkboxs.forEach(checkbox => {
                checkbox.removeEventListener('change', this.handleOptionChange)
            })

            // 清空缓存
            this.checkboxs = []
            this.checkboxValueMap = new WeakMap()
            this.valueCheckboxMap.clear()

            // 重新收集
            this.checkboxs = [...this.querySelectorAll('.ly-main-product-form-variant-picker-option-picker-checkbox')]

            this.checkboxs.forEach(checkbox => {

                const value = checkbox.dataset.showValue ?? checkbox.value

                this.checkboxValueMap.set(checkbox, value)

                this.valueCheckboxMap.set(value, checkbox)

                checkbox.addEventListener('change', this.handleOptionChange)
            })
        }

        get selectedOptions() {
            const picker = this.closest('ly-main-product-form-variant-picker')

            const [option1, option2, option3] = picker.activedKey.split(' | ')

            return { option1, option2, option3 }
        }

        get selectedVariantId() {
            const picker = this.closest('ly-main-product-form-variant-picker')

            return Number(picker.keyIdMap[picker.activedKey])
        }
    })
}

if (!customElements.get('ly-main-product-form-variant-picker-line-v2_5-option3')) {
    customElements.define('ly-main-product-form-variant-picker-line-v2_5-option3', class extends LyMainProductFormVariantPickerLineBase {

        options = null
        sizes = null
        types = null

        connectedCallback() {
            super.connectedCallback()

            const optionsScript = this.querySelector('script[type="application/json"][data-options]')
            if (optionsScript) {
                this.options = readJsonFromScript(optionsScript)
            }

            const sizesScript = this.querySelector('script[type="application/json"][data-sizes]')
            if (sizesScript) {
                this.sizes = readJsonFromScript(sizesScript)
            }

            const typesScript = this.querySelector('script[type="application/json"][data-types]')
            if (typesScript) {
                this.types = readJsonFromScript(typesScript)
            }

            this.contentsWrapper = this.querySelector('.ly-main-product-form-variant-picker-option-container')

            this.layoutChangeUnsubcscriber = window.subscribe('bus:ly-main-product-form-variant-picker-line-v2-option1:change', this.handleLayoutChange)
        }

        disconnectedCallback() {

            this.layoutChangeUnsubcscriber?.()

            super.disconnectedCallback()
        }

        handleLayoutChange = (layout) => {
            const currentTypes = this.types.filter(type => type.layout === layout)
            const activeType = currentTypes.find(type => {
                return type.variants.some(id => this.selectedVariantId === id)
            })

            this.renderContents(currentTypes, activeType)

            this.refresh()
        }

        renderContents = (currentTypes, activeType) => {
            const { option1, option2, option3 } = this.selectedOptions

            const html = currentTypes.map(type => {
                return this.sizes.flatMap(size => {

                    const matchedVariants =
                        size.variants.filter(variant => {
                            const [vOption1, vOption2] = variant.options
                            return (vOption1 === option1 && vOption2 === option2)
                        })

                    if (!matchedVariants.length) {
                        return []
                    }

                    return matchedVariants.flatMap(matchedVariant => {
                        if (!type.variants.includes(matchedVariant.id)) {
                            return []
                        }

                        const checked = matchedVariant.options[2] === option3

                        const option = this.options.find(item => item.value === matchedVariant.options[2])

                        let componentsTitleHtml = ''

                        if (size.componentsTitle) {
                            componentsTitleHtml = `
                                <div class="ly-main-product-form-variant-picker-option-components-title">
                                    ${size.componentsTitle}
                                </div>
                                `
                        }

                        let tagHtml = ''

                        if (size.tag) {
                            tagHtml = `
                                <div class="ly-main-product-form-variant-picker-option-tag">
                                    ${size.tag}
                                </div>
                                `
                        }

                        return `
                            <label class="ly-main-product-form-variant-picker-option v2-pergola-option3">
                            
                            <div class="ly-main-product-form-variant-picker-option-title ly-p">
                                ${size.showTitle}
                            </div>

                            ${componentsTitleHtml}

                            ${tagHtml}

                            <input
                                class="ly-main-product-form-variant-picker-option-picker-checkbox"
                                type="radio"
                                name="Pergola Size"
                                value="${matchedVariant.options[2]}"
                                data-show-value="${size.showTitle}"
                                data-option-id="${option?.id ?? ''}"
                                ${checked ? 'checked' : ''}
                                ${!matchedVariant.available ? 'disabled' : ''}
                                hidden
                            >
                        </label>
                        `
                    })
                }).join('')
            }).join('')

            this.contentsWrapper.innerHTML = `
            <div class="ly-main-product-form-variant-picker-option-wrapper has-v2-pergola-option3 is-visible">
                ${html}
            </div>
            `
        }

        refresh = () => {
            // 移除旧监听
            this.checkboxs.forEach(checkbox => {
                checkbox.removeEventListener('change', this.handleOptionChange)
            })

            // 清空缓存
            this.checkboxs = []
            this.checkboxValueMap = new WeakMap()
            this.valueCheckboxMap.clear()

            // 重新收集
            this.checkboxs = [...this.querySelectorAll('.ly-main-product-form-variant-picker-option-picker-checkbox')]

            this.checkboxs.forEach(checkbox => {

                const value = checkbox.dataset.showValue ?? checkbox.value

                this.checkboxValueMap.set(checkbox, value)

                this.valueCheckboxMap.set(value, checkbox)

                checkbox.addEventListener('change', this.handleOptionChange)
            })
        }

        get selectedOptions() {
            const picker = this.closest('ly-main-product-form-variant-picker')

            const [option1, option2, option3] = picker.activedKey.split(' | ')

            return { option1, option2, option3 }
        }

        get selectedVariantId() {
            const picker = this.closest('ly-main-product-form-variant-picker')

            return Number(picker.keyIdMap[picker.activedKey])
        }
    })
}